import functions from "./functions";
import mixins from "./mixins";
import variables from "./variables";

export default { functions, mixins, ...variables };
